module.exports = __webpack_public_path__ + "img/award-b.6684e26a.png";